<template>
	<div class="newscontent">
		<div class="tabcon">
			<div :class="tabindex == 0?'black_cur':'black'" @click="changetab(0)">新闻中心</div>
			<div :class="tabindex == 1?'black_cur':'black'" @click="changetab(1)">公示公告</div>
		</div>
		
		<div class="cencon" v-for="(item,index) in list" v-if="tabindex == 0" @click="tonewsdetail(item)">
			<div class="time">
				<div class="day">{{item.createTime?item.createTime.substring(8,10):''}}</div>
				<div class="yearmonth">{{item.createTime?item.createTime.substring(0,7):''}}</div>
			</div>
			<div class="line"></div>
			<div class="info">
				<div class="title" :title="item.title">{{item.title?item.title.substring(0,24):''}}</div>
				<div class="details">{{gethypertext(item.content)}}</div>
			</div>
		</div>
		
		<div class="cencon" v-for="(item,index) in list" v-if="tabindex == 1" @click="todetail(item)">
			<div class="time">
				<div class="day">{{item.createTime?item.createTime.substring(8,10):''}}</div>
				<div class="yearmonth">{{item.createTime?item.createTime.substring(0,7):''}}</div>
			</div>
			<div class="line"></div>
			<div class="info">
				<div class="title" :title="item.titile">{{item.titile?item.titile.substring(0,24):''}}</div>
				<div class="details">{{item.msgAbstract || ''}}</div>
			</div>
		</div>
				
		
	</div>
	
</template>

<script>


export default {
 
  data: function() {
		return {
		    tabindex:0,
		    list:[],
						
		};
  },
  
  methods: {
		//过滤富文本
		gethypertext(str){
			if(str == null){
				return "";
			}
			var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
			              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
			str = str.substring(0,50);
			return str;
		},
	  
		changetab(sign){
			this.tabindex = sign
			if(this.tabindex == 0){
				this.getnewsList()
			}else if(this.tabindex == 1){
				this.getwebList()
			}
			
			this.$emit('receiveSign', sign);			
		},
		
		getwebList() {
			   var that = this;
			   this.httpGet("web/annountCement/webList", {
					 sort: "sendTime",
					 pageNo: 1,
					 pageSize: 4,
			   }).then((res) => {
					 that.list = res.result.records;
			   });
		},
		
		getnewsList() {
			   var that = this;
			   this.httpGet("web/info/list", {
					 infoType: "6",
					 pageNo: 1,
					 pageSize: 4,
			   }).then((res) => {
					 that.list = res.result.records;
			   });
		},
		
		tonewsdetail(item){
			this.$router.push({
				  path: "/newscenterdetail",
				  query: { id: item.id },
			});	
		},
		
		todetail(item){
			this.$router.push({
			  path: "/noticeDetails",
			  query: { id: item.id },
			});	
		},
		
  },
  
  mounted() {
	 this.getnewsList();
	 
	 
  }
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.newscontent{
	
	.tabcon{
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		.black_cur{
			cursor: pointer;
			width: 160px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			background: #E50112;
			font-size: 20px;
			font-weight: 400;
			color: #FFFFFF;
		}
		.black{
			cursor: pointer;
			width: 160px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			background: #EEEEEE;
			font-size: 20px;
			font-weight: 400;
			color: #333333;
		}
	}
	
	
	.cencon{
		cursor: pointer;
		display: flex;
		align-items: center;
		margin-bottom:10px;
		.time{
			width: 100px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.day{
				color:#999999;
				font-size: 40px;
				font-weight: bold;
				height: 40px;
				line-height:40px;
			}

			.yearmonth{
				color:#999999;
				font-size: 14px;
				font-weight: 400;
			}

		}
		
		.line{
			width: 1px;
			height: 53px;
			background: #CCCCCC;
		}
		.info{
			flex: 1;
			margin-left: 20px;
			.title{
				font-size: 18px;
				font-weight: 400;
				color: #000000;
				height: 40px;
				line-height: 40px;
			}
			.details{
				font-size:16px;
				font-weight: 400;
				color: #666666;
				min-height: 40px;
			}
		}
	}
	
	.cencon:hover .time .day{
		color: #E50112;
	}
	.cencon:hover .time .yearmonth{
		color: #E50112;
	}
	.cencon:hover .line{
		background: #E50112;
	}
	.cencon:hover .info .title{
		color: #E50112;
	}
	.cencon:hover .info .details{
		color: #E50112;
	}
	
	
	
	
	
}

</style>
